/**
 * Profawz logo
 *
 * Concept:
 * - Square frame (industrial / structured)
 * - Upward steps + arrow tip (progression)
 * - Lightning bolt accent (électrotechnique / énergie)
 * - Green primary brand color
 */
export default function ProfawzLogo({ size = 32, className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            aria-label="Profawz"
            role="img"
        >
            {/* Frame (industrial) */}
            <rect x="2" y="2" width="36" height="36" rx="3" fill="#0A0A0A" />
            {/* Progression bars (steps growing) */}
            <rect x="9" y="22" width="5" height="10" rx="0.6" fill="#15A36A" />
            <rect x="16" y="17" width="5" height="15" rx="0.6" fill="#22C075" />
            <rect x="23" y="11" width="5" height="21" rx="0.6" fill="#15A36A" />
            {/* Lightning bolt across the steps (industrial / fast / electrical) */}
            <path
                d="M28 6 L20 20 L24 20 L19 32 L29 17 L25 17 L29 6 Z"
                fill="#FFFFFF"
                stroke="#0A0A0A"
                strokeWidth="0.6"
                strokeLinejoin="round"
            />
        </svg>
    );
}
